
export const StorageKey = {
	Session: 'gBr77yPwYG',
	Cart: 'RW9pPRxjyL',
	Money: 'suBaSJCfSR',
	Events: 'Xv2Lm8QaPd',
};